var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { ImagePreview } from 'Components.Camera';
import { Button } from 'Components.Form';
import { FormattedMessage } from 'Intl';
import styled from 'styled-components';
var CameraWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  #outer-circle {\n    left: -37px;\n    height: 75px;\n    width: 75px;\n    background-color: hsl(7deg 100% 50% / 40%)!important;\n    z-index: 1;\n  }\n  #inner-circle {\n    left: 50%;\n    top: 38px;\n    height: 44px;\n    width: 44px;\n    background: #ff0000!important;\n    margin: -22px 0 0 -22px;\n    z-index: 2;\n  }\n"], ["\n  #outer-circle {\n    left: -37px;\n    height: 75px;\n    width: 75px;\n    background-color: hsl(7deg 100% 50% / 40%)!important;\n    z-index: 1;\n  }\n  #inner-circle {\n    left: 50%;\n    top: 38px;\n    height: 44px;\n    width: 44px;\n    background: #ff0000!important;\n    margin: -22px 0 0 -22px;\n    z-index: 2;\n  }\n"])));
var CameraTools = function (_a) {
    var _b = _a.baseId, baseId = _b === void 0 ? '' : _b, props = __rest(_a, ["baseId"]);
    var _c = useState(''), dataUri = _c[0], setDataUri = _c[1];
    var handleTakePhotoAnimationDone = function (nextDataUri) {
        setDataUri(nextDataUri);
    };
    var handleTakePhoto = function (nextDataUri) {
        props.onConfirm(nextDataUri);
    };
    var handleRetake = function () {
        setDataUri('');
    };
    return (React.createElement("div", null, (dataUri)
        ? (React.createElement(React.Fragment, null,
            React.createElement(ImagePreview, { dataUri: dataUri }),
            React.createElement(Button, { id: "".concat(baseId, "_retake_button"), primary: true, fullWidth: true, onClick: handleRetake },
                React.createElement(FormattedMessage, { id: 'cameraTools.retakePhoto' }))))
        : (React.createElement(CameraWrapper, null,
            React.createElement(Camera, { onTakePhoto: handleTakePhoto, onTakePhotoAnimationDone: handleTakePhotoAnimationDone, idealFacingMode: FACING_MODES.ENVIRONMENT, idealResolution: { width: 640, height: 480 }, imageType: IMAGE_TYPES.JPG, imageCompression: 0.97, isMaxResolution: true, isImageMirror: false, isSilentMode: false, isDisplayStartCameraError: true, isFullscreen: false, sizeFactor: 1 })))));
};
export default CameraTools;
var templateObject_1;
